module.exports = __webpack_public_path__ + "assets/img/Events-Image.bb1fe62d.jpg";